import { Select, type SelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { TSession } from "@/types"

export function SelectVisibility({
  value,
  onChange,
  ...props
}: SelectProps & {
  value?: TSession["visibility"]
  onChange: (value: TSession["visibility"]) => void
}) {
  const { t } = useTranslation()

  const choices = [
    { value: "public", label: t("public") },
    { value: "managers", label: t("managers") },
    { value: "admins", label: t("admins") },
  ]

  return (
    <Select
      allowDeselect={false}
      label={t("Visibility")}
      {...props}
      data={choices}
      value={value}
      onChange={(value) => onChange(value as TSession["visibility"])}
    />
  )
}
